import axios from "axios";
import { KEY_USER } from "../utilities/constants";

const { BASE_URL } = process.env;

const API = axios.create({
  baseURL: BASE_URL,
});

// Add request interceptor to include Authorization header
API.interceptors.request.use(
  function (config) {
    // Get user from localStorage
    const userStr = localStorage.getItem(KEY_USER);
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user && user.token) {
          config.headers.Authorization = `Bearer ${user.token}`;
        }
      } catch (error) {
        console.error('Error parsing user from localStorage:', error);
      }
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  function (response) {
    return response.data;
  },
  function (error) {
    // Handle network errors or errors without response
    if (!error.response) {
      console.error("Network error or no response:", error.message);
      return Promise.reject(error);
    }

    // Handle 401 Unauthorized - user needs to re-authenticate
    if (error.response && error.response.status === 401) {
      console.warn("Authentication failed (401) - user may need to re-login");
      // Clear user data from localStorage
      localStorage.removeItem(KEY_USER);
      // Redirect to login page
      window.location.href = "/login";
      return Promise.reject(error);
    }

    // Handle 403 Forbidden
    if (error.response && error.response.status === 403) {
      const url = error.config?.url ?? "unknown";
      const method = error.config?.method?.toUpperCase() ?? "unknown";
      const baseURL = error.config?.baseURL;

      console.warn("Access forbidden (403):", {
        url,
        baseURL,
        method,
        responseData: error.response?.data,
      });
    }

    return Promise.reject(error);
  }
);

export default API;
